import { call, put, takeLatest, select, delay } from "redux-saga/effects";
import ActionTypeConstants from "helpers/ActionTypeConstants";
import { actionApiCall } from "helpers/api/ApiCalls";

const getItems = state => state.SitesReducer.sites;
const getActs = state => state.ActsReducer.acts;
const getSelected = state => state.UserOrgSiteReducer.selected;

function transformAudits(audits, sites, acts) {
    const result = audits.map(audit => {
        audit.status = audit.configuration.status_label;
        if (sites) {
            sites.forEach(item => {
                if (item.id === audit.site) {
                    audit.siteName = item.name;
                }
            });
        }
        audit.frequency_label = `${audit.configuration.frequency_label} ${audit.configuration.reset ? '(Reset)' : ''}`;
        if (acts) {
            acts.forEach(item => {
                if (item.id === audit.act) {
                    audit.actName = item.name;
                }
            });
        }
        if (audit.act === "6") {
            audit.status = 'Ongoing';
        }
        return audit;
    });
    return result;
}

function* loadAuditsSaga() {
    try {
        const selected = yield select(getSelected);
        const apiResponse = yield call(actionApiCall, {
            actionType: ActionTypeConstants.LOAD_AUDITS,
            data: {
                organization: selected.org,
            }
        });
        if (apiResponse.res.data.response === 200) {
            const { data } = apiResponse.res.data;
            const sites = yield select(getItems);
            const acts = yield select(getActs);
            yield put({
                type: ActionTypeConstants.LOAD_AUDITS_SUCCESS,
                payload: {
                    audits: transformAudits(data, sites, acts)
                }
            });
        } else {
            yield put({
                type: ActionTypeConstants.SHOW_ALERT,
                payload: {
                    message: apiResponse.res.data.message || "An issue occurred while loading audits",
                    color: "danger"
                }
            });
            yield delay(10000)
            yield put({ type: ActionTypeConstants.HIDE_ALERT });
        }
    } catch (err) {
        yield put({
            type: ActionTypeConstants.SHOW_ALERT,
            payload: {
                message: "An issue occurred while loading audits",
                color: "danger"
            }
        });
        yield delay(10000)
        yield put({ type: ActionTypeConstants.HIDE_ALERT });
    }
}

export default function*() {
    yield takeLatest(ActionTypeConstants.LOAD_AUDITS, loadAuditsSaga);
}
